export const messages = {
  fr: {
    "URBAN AREA": "Zone urbaine",
    "ACTIVITY AREA": `Zone d'activité`,
    "RURAL AREA": "Zone rurale",
    "NATURAL AREA": "Zone naturelle",
    "COLLECTIVE GREEN SPACES": "Espaces verts collectifs",
    "AGRICULTURAL LAND": "Terrains agricoles",
    "PRIVATE GARDENS": "Jardins privatifs",
    "STABILIZED PARKING OR CIRCULATION AREAS": "Zones de Stationnement ou circulation stabilisées",
    TERTIARY: "tertiaire",
    TERTIAIRE: "Tertiaire",
    INDUSTRIAL: "industriel",
    INDUSTRIEL: "Industriel",
    "INDIVIDUAL RESIDENTIAL": "résidentiel individuel",
    RESIDENTIEL_INDIVIDUEL: "Résidentiel individuel",
    "COLLECTIVE RESIDENTIAL": "résidentiel collectif",
    RESIDENTIEL_COLLECTIF: "Résidentiel collectif",
    "DISPERSED RESIDENTIAL": "résidentiel dispersé",
    RESIDENTIEL_DISPERSE: "Résidentiel dispersé",
    "COMMERCIAL ARTISANAL": "artisanal-commercial",
    ARTISANAL_COMMERCIAL: "Artisanal-commercial",
    "SENSITIVE ESTABLISHMENT": "établissement sensible",
    ETABLISSEMENT_SENSIBLE: "Etablissement sensible",
    "NO PRESENCE": "Aucune présence",
    NO_PRESENCE: "Aucune présence",
    WORKERS: "Travailleurs",
    "ADULT RESIDENTS": "Résidents adultes",
    ADULT_RESIDENTS: "Résidents adultes",
    "CHILDREN RESIDENTS": "Résidents enfants",
    CHILD_RESIDENTS: "Résidents enfants",
    "SENIOR RESIDENTS": "Résidents séniors",
    SENIOR_RESIDENTS: "Résidents séniors",
    STUDENTS: "Elèves",
    PATIENTS: "Patients",
    "NORTH-WEST": "Nord-Ouest",
    "NORTH-EAST": `Nord-Est`,
    "SOUTH-WEST": "Sud-Ouest",
    "SOUTH-EAST": "Sud-Est",
    CENTER: "Centre",
    EAST: "Est",
    WEST: "Ouest",
    SOUTH: "Sud",
    NORTH: "Nord",
    UPSTREAM: "Amont",
    DOWNSTREAM: "Aval",
    LATERAL: "Latéral",
    "DON'T KNOW": "Ne sait pas",
    "PROTECTED AREA": "éspace protégé",
    AGRICOLE: "agricole",
    CLIENTS: "Clients",
    "PASSERS-BY": "Passants",
    ROADS: "Voiries (stationnement/circulation)",
    "STABILIZED GROUND": "Terrain stabilisé",
    "BARE GROUND": "Terrain nu",
    MARE: "Mare",
    WATERCOURSE: "Cours d'eau",
    FLOORS: "Sols",
    EXCAVATED_SOIL: "Terres excavées",
    "EXCAVATED SOIL": "Terres excavées",
    "LAND TO BE EXCAVATED": "Terres à excaver",
    "UNDERGROUND WATERS": "Eaux souterraines",
    "SURFACE WATERS": "Eaux superficielles",
    UNDERGROUND_WATERS: "Eaux souterraines",
    SURFACE_WATERS: "Eaux superficielles",
    SEDIMENTS: "Sédiments",
    "SOIL GASE": "Gaz du sol",
    SOIL_GAS: "Gaz du sol",
    "AMBIANT AIR": "Air ambiant",
    AMBIANT_AIR: "Air ambiant",
    SOIL_TO_EXCAVATE: "Terres à excaver",
    DUST: "Poussières",
    PLANTS: "Végétaux",
    SEVESO_HIGH: "SEVESO seuil haut",
    SEVESO_LOW: "SEVESO seuil bas",
    AUTHORISATION: "Autorisation",
    REGISTRATION: "Enregistrement",
    DECLARATION: "Déclaration",
    CONTROLLED_DECLARATION: "Déclaration soumise à contrôle",
    NOT_CLASSIFIED: "Non classé",
    AUTHORISATION_DOCUMENT: "Arrêté préfectoral d'autorisation",
    REGISTRATION_DOCUMENT: "Arrêté préfectoral d'enregistrement",
    DECLARATION_DOCUMENT: "Récépissé de déclaration",
    ICPE_CLASSIFICATIONS: "Classements ICPE",
    ACTIVITIES: "Activités",
    PRODUCTS: "Produits / Déchets",
    ACCIDENTS: "Accidents",
    USAGE_RESTRICTIONS: "Restrictions d'usage/Servitudes",
    KNOWN_POLLUTION_SITES: "Pollutions des milieux connues",
    BOMBINGS: "Bombardements",
    RAW_MATERIAL: "Matière première",
    NEW_PRODUCTS: "Produits neufs",
    USED_PRODUCTS: "Produits usagers",
    WASTE: "Déchets",
    SENSITIVE_ESTABLISHMENT: "Établissement sensible",
    YES: "Oui",
    NO: "Non",
    PLAN: "Plan",
    REPORT: "Rapport",
    ENVIRONMENTAL_REPORT: "Rapport Pollution des milieux",
    LEVE: "LEVE",
    INFOS: "INFOS",
    DIAG: "DIAG",
    SUIVI: "SUIVI",
    PG: "PG",
    ELEM: "ELEM",
    A100: "A100",
    A110: "A110",
    A120: "A120",
    A130: "A130",
    A200: "A200",
    A210: "A210",
    A220: "A220",
    A230: "A230",
    A240: "A240",
    A250: "A250",
    A260: "A260",
    A270: "A270",
  },

  en: {
    "ACTIVITY AREA": "Activity area",
    "URBAN AREA": "Urban area",
    "NATURAL AREA": "Natural area",
    "RURAL AREA": "Rural area",
    "COLLECTIVE GREEN SPACES": "Collective green spaces",
    "PRIVATE GARDENS": "Private gardens",
    "AGRICULTURAL LAND": "Agricultural land",
    "STABILIZED PARKING OR CIRCULATION AREAS": "Stabilized parking or circulation areas",
    TERTIARY: "tertiary",
    INDUSTRIAL: "Industrial",
    TERTIAIRE: "Tertiary",
    "INDIVIDUAL RESIDENTIAL": "individual residential",
    INDUSTRIEL: "Industrial",
    "COLLECTIVE RESIDENTIAL": "collective residential",
    RESIDENTIEL_INDIVIDUEL: "Individual residential",
    "DISPERSED RESIDENTIAL": "dispersed residential",
    RESIDENTIEL_COLLECTIF: "Collective residential",
    "COMMERCIAL ARTISANAL": "commercial artisanal",
    RESIDENTIEL_DISPERSE: "Dispersed residential",
    "SENSITIVE ESTABLISHMENT": "sensitive establishment",
    ARTISANAL_COMMERCIAL: "Commercial artisanal",
    ETABLISSEMENT_SENSIBLE: "Sensitive establishment",
    NO_PRESENCE: "No presence",
    "NO PRESENCE": "No presence",
    "ADULT RESIDENTS": "Adult residents",
    WORKERS: "Workers",
    "CHILDREN RESIDENTS": "Children residents",
    ADULT_RESIDENTS: "Adult residents",
    "SENIOR RESIDENTS": "Senior residents",
    CHILD_RESIDENTS: "Children residents",
    STUDENTS: "Students",
    SENIOR_RESIDENTS: "Senior residents",
    "NORTH-WEST": "North-West",
    PATIENTS: "Patients",
    "SOUTH-WEST": "South-West",
    "NORTH-EAST": "North-East",
    CENTER: "Center",
    "SOUTH-EAST": "South-East",
    WEST: "West",
    EAST: "East",
    NORTH: "North",
    SOUTH: "South",
    DOWNSTREAM: "Downstream",
    UPSTREAM: "Upstream",
    "DON'T KNOW": "Don't know",
    LATERAL: "Lateral",
    AGRICOLE: "agricultural",
    "PROTECTED AREA": "protected area",
    "PASSERS-BY": "Passers-by",
    CLIENTS: "Clients",
    ROADS: "Roads",
    "BARE GROUND": "Bare ground",
    "STABILIZED GROUND": "Stabilized ground",
    MARE: "Pond",
    FLOORS: "Floors",
    WATERCOURSE: "Watercourse",
    "LAND TO BE EXCAVATED": "Land to be excavated",
    "EXCAVATED SOIL": "Excavated soil",
    "SURFACE WATERS": "Surface waters",
    "UNDERGROUND WATERS": "Underground waters",
    EXCAVATED_SOIL: "Excavated soil",
    SURFACE_WATERS: "Surface waters",
    UNDERGROUND_WATERS: "Underground waters",
    "SOIL GASE": "Soil gas",
    SEDIMENTS: "Sediments",
    PLANTS: "Plants",
    "AMBIANT AIR": "Ambiant air",
    SEVESO_LOW: "Seveso lower threshold",
    AUTHORISATION: "Authorization",
    SEVESO_HIGH: "Seveso upper threshold",
    DECLARATION: "Declaration",
    REGISTRATION: "Registration",
    NOT_CLASSIFIED: "Not classified",
    CONTROLLED_DECLARATION: "Declaration subject to control",
    ACTIVITIES: "Activities",
    ICPE_CLASSIFICATIONS: "ICPE Classifications",
    ACCIDENTS: "Accidents",
    PRODUCTS: "Products / Waste",
    USAGE_RESTRICTIONS: "Usage Restrictions / Servitudes",
    KNOWN_POLLUTION_SITES: "Known Pollution Sites",
    BOMBINGS: "Bombings",
    RAW_MATERIAL: "Raw Material",
    NEW_PRODUCTS: "New Products",
    USED_PRODUCTS: "Used Products",
    WASTE: "Waste",
    SENSITIVE_ESTABLISHMENT: "Sensitive establishment",
    DUST: "Dust",
    AUTHORISATION_DOCUMENT: "Authorization document",
    REGISTRATION_DOCUMENT: "Registration document",
    DECLARATION_DOCUMENT: "Declaration document",
    YES: "Yes",
    NO: "No",
  },
};
